var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_229_31687"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_229_31687)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.37225,1.875C6.923500000000001,1.875,12.5,1.875,12.5,1.875C12.5,1.875,16.875,6.875,16.875,6.875C16.875,6.875,16.875,13.9629,16.875,16.886699999999998C16.875,17.5771,16.2964,18.125,15.6061,18.125C12.98767,18.125,7.01233,18.125,4.39392,18.125C3.703565,18.125,3.125,17.5833,3.125,16.892899999999997C3.125,13.8727,3.125,6.12732,3.125,3.1070599999999997C3.125,2.4167,3.681896,1.875,4.37225,1.875",
    fillRule: "evenodd",
    fill: "#0BB52D",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.133985,7.792822C7.133293,7.791957,7.132604,7.79109,7.131919,7.790221C7.02576746,7.655627,7.164696,7.5,7.336113,7.5C7.536809,7.5,7.790843,7.5,7.949501,7.5C8.04443,7.5,8.13553,7.5440182,8.19483,7.618148C8.57861,8.097872,10.00002,9.87463,10.00002,9.87463C10.00002,9.87463,11.421420000000001,8.097872,11.8052,7.618148C11.86451,7.5440182,11.9556,7.5,12.05053,7.5C12.20919,7.5,12.46323,7.5,12.663920000000001,7.5C12.83534,7.5,12.97427,7.655627,12.868120000000001,7.790221C12.867429999999999,7.79109,12.86674,7.791957,12.866050000000001,7.792822C12.866050000000001,7.792822,10.60031,10.625,10.60031,10.625C10.60031,10.625,12.866050000000001,13.45717,12.866050000000001,13.45717C12.86674,13.45803,12.867429999999999,13.4589,12.868120000000001,13.459769999999999C12.97427,13.59437,12.83535,13.75,12.663920000000001,13.75C12.46323,13.75,12.2092,13.75,12.05054,13.75C11.95561,13.75,11.86451,13.70598,11.805209999999999,13.63185C11.42143,13.15213,10.00002,11.37536,10.00002,11.37536C10.00002,11.37536,8.57861,13.15213,8.19483,13.63185C8.13552,13.70598,8.04443,13.75,7.949495,13.75C7.790838,13.75,7.536805,13.75,7.336111,13.75C7.164689,13.75,7.02576438,13.59437,7.131919,13.459769999999999C7.132604,13.4589,7.133293,13.45803,7.133985,13.45717C7.133985,13.45717,9.39972,10.625,9.39972,10.625C9.39972,10.625,7.133985,7.792822,7.133985,7.792822Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,1.875C12.5,1.875,12.5,4.1195,12.5,5.6008700000000005C12.5,6.29123,13.057254,6.875,13.74761,6.875C15.04075,6.875,16.875,6.875,16.875,6.875C16.875,6.875,12.5,1.875,12.5,1.875Z",
    fillRule: "evenodd",
    fill: "#00914E",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.bb39aa6b0d064e56aa38d8754e1cc2c2.svg";
export { ForwardRef as ReactComponent };